@if (show()) {
  <div class="container">
    <div class="container--header">
      <div class="title">{{ title() }}</div>
      @if (showCloseButton()) {
        <div class="close-button" (click)="closeModal()"></div>
      }
    </div>
    <div class="container--body">
      <ng-content select="[body]" />
    </div>
    @if (showLine()) {
      <hr />
    }
    <div class="container--footer">
      <ng-content select="[footer]" />
    </div>
  </div>
}
